import { getAxiosClient } from "../../axios-client";
import { AddUserRequestBody, AddUserResponse } from "./types";

const axiosClient = getAxiosClient();
export const addUser = async (body: AddUserRequestBody) => {
  return await axiosClient.ax.post<AddUserResponse>(
    "/Users/Add",
    body
  );
};
